import React, { useState, useEffect } from "react";
import { Button, Panel } from "react-bootstrap";
import "./Answer.css";
import { ArrowUpCircle } from 'react-feather';
import DOMPurify from 'dompurify'
import draftToHtml from 'draftjs-to-html';
import defaultAvatar from "../assets/avatar.png"
import { ContentState, convertToRaw, convertFromRaw } from 'draft-js';

export default function Answer({
  idx,
  answer,
  answers,
  deleteAnswer,
  interact,
  truncated,
}) {
  const regularHtml = DOMPurify.sanitize(draftToHtml(JSON.parse(answer.text))) 
  const [answerHtml, setAnswerHtml] = useState(regularHtml);
  const [displayReadMore, setDisplayReadMore] = useState(true);

  const truncate = (contentState, charCount = 600) => {
    const blocks = contentState.getBlocksAsArray();
  
    let index = 0;
    let currentLength = 0;
    let isTruncated = false;
    const truncatedBlocks = [];
  
    while (!isTruncated && blocks[index]) {
      const block = blocks[index];
      const length = block.getLength();
      if (currentLength + length > charCount) {
        isTruncated = true;
        const truncatedText = block
          .getText()
          .slice(0, charCount - currentLength);
        const state = ContentState.createFromText(`${truncatedText}...`);
        truncatedBlocks.push(state.getFirstBlock());
      } else {
        truncatedBlocks.push(block);
      }
      currentLength += length + 1;
      index++;
    }
  
    if (isTruncated) {
      truncated = true
      return ContentState.createFromBlockArray(truncatedBlocks);
    }
  
    return contentState;
  };
  const truncatedState = truncate(convertFromRaw(JSON.parse(answer.text)))
  const truncatedHtml = DOMPurify.sanitize(draftToHtml(convertToRaw(truncatedState)));

  useEffect(() => {
    setAnswerHtml(truncatedHtml)
  }, [truncated, truncatedHtml]);
  
  return (
    <Panel className="poll-answer-panel">
      <Panel.Heading className="poll-answer-panel-heading">
        <div style={{paddingBottom: "10px"}}>
          <div
            style={{backgroundImage: `url(${answer.author.avatarURL}), url(${defaultAvatar})`}}
            className="article-avatar"
          />
          <div className="profile-text-card" style={{marginTop: "3px"}}>
            <span className="author-name">
            { answer.author.fullname }
            </span>
            <span style={{wordBreak: "break-all"}}>
              {answer.author.credential ? `, ${answer.author.credential}` : null }
              <br/>
            </span>
            <span className="text-muted">
              Answered { 
                new Intl.DateTimeFormat('en-US', { 
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric' 
                }).format(new Date(answer.date))
               }
            </span>
          </div>
        </div>
      </Panel.Heading>
      <Panel.Body style={{marginTop: "-10px"}}>
        <div>
          <div style={{paddingBottom: "15px", "clear": "both"}}>
            <span className="comment-text">
              { <div dangerouslySetInnerHTML={{ __html: answerHtml }} /> }
              { truncated && displayReadMore ? 
               ( <Button 
                    onClick={() => {setAnswerHtml(regularHtml); setDisplayReadMore(false)}}
                    className="btn-link btn-anchor"
                  >
                  (Read More)
                </Button>

                ) : null
               }
            </span>
            <div style={{display: "flex", justifyContent: "space-between", paddingLeft: "10px", paddingTop: "5px"}}>
              <span 
                className="interaction-btn"
                style={answer.upVoted ? {color: '#ff7f01'} : null}
                onClick={()=>interact(answers, 'up', idx)}
              >
                <ArrowUpCircle style={{verticalAlign: "-3px"}} strokeWidth={3} size={18} /> {answer.ups}
              </span>
              <span className="award-text">
                { answer.award ? `+${answer.award} i¢` : null }
                { !answer.awarded ? <Button onClick={()=>interact(answers, 'award', idx)} className="award-btn">award i¢</Button> : null }
              </span>
              {
                answer.canDelete ? (
                  <span className="award-text" style={{marginRight: "5px"}}>
                    <Button 
                      onClick={()=>deleteAnswer(answers, idx, answer)} 
                      className="award-btn"
                    >
                      edit
                    </Button>
                  </span>
                ) : null
              }
            </div>
          </div>
        </div>
      </Panel.Body>
    </Panel>
    );
}